(function () {
  const section = document.querySelector("[data-visual-proof]");
  if (!section || typeof Swiper === "undefined") return;

  const swiperEl = section.querySelector("[data-visual-proof-swiper]");
  const progressEl = section.querySelector("[data-visual-proof-progress]");
  const prevButtons = section.querySelectorAll("[data-visual-proof-prev]");
  const nextButtons = section.querySelectorAll("[data-visual-proof-next]");
  const cards = section.querySelectorAll("[data-visual-proof-card]");

  if (!swiperEl) return;

  const swiper = new Swiper(swiperEl, {
    slidesPerView: "auto",
    spaceBetween: 12,
    grabCursor: true,
    watchOverflow: true,
    pagination: {
      el: progressEl,
      type: "progressbar",
    },
    breakpoints: {
      769: {
        spaceBetween: 13,
      },
    },
  });

  function updateNavState() {
    const isBeginning = swiper.isBeginning;
    const isEnd = swiper.isEnd;

    prevButtons.forEach(function (btn) {
      btn.disabled = isBeginning;
      btn.classList.toggle("swiper-button-disabled", isBeginning);
    });

    nextButtons.forEach(function (btn) {
      btn.disabled = isEnd;
      btn.classList.toggle("swiper-button-disabled", isEnd);
    });
  }

  function setPlayIcon(card, isPlaying) {
    const playBtn = card.querySelector("[data-visual-proof-play]");
    const playIcon = card.querySelector("[data-visual-proof-play-icon]");
    const pauseIcon = card.querySelector("[data-visual-proof-pause-icon]");
    if (!playBtn || !playIcon || !pauseIcon) return;

    playIcon.hidden = isPlaying;
    pauseIcon.hidden = !isPlaying;
    playBtn.setAttribute("aria-label", isPlaying ? "Pause video" : "Play video");
  }

  function setMuteIcon(card, muted) {
    const muteBtn = card.querySelector("[data-visual-proof-mute]");
    const muteIcon = card.querySelector("[data-visual-proof-mute-icon]");
    const unmuteIcon = card.querySelector("[data-visual-proof-unmute-icon]");
    if (!muteBtn || !muteIcon || !unmuteIcon) return;

    muteIcon.hidden = !muted;
    unmuteIcon.hidden = muted;
    muteBtn.setAttribute("aria-label", muted ? "Unmute video" : "Mute video");
  }

  function stopCard(card) {
    const video = card.querySelector("video");
    card.classList.remove("is-playing");
    setPlayIcon(card, false);
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      setMuteIcon(card, true);
    }
  }

  function stopOthers(except) {
    cards.forEach(function (card) {
      if (card !== except) stopCard(card);
    });
  }

  function playCard(card) {
    const video = card.querySelector("video");
    if (!video) return;

    stopOthers(card);
    card.classList.add("is-playing");
    setPlayIcon(card, true);
    video.muted = true;
    setMuteIcon(card, true);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }

    requestAnimationFrame(function () {
      swiper.update();
      updateNavState();
    });
  }

  function pauseCard(card) {
    const video = card.querySelector("video");
    card.classList.remove("is-playing");
    setPlayIcon(card, false);
    if (video) video.pause();

    requestAnimationFrame(function () {
      swiper.update();
      updateNavState();
    });
  }

  function toggleCard(card) {
    if (card.classList.contains("is-playing")) {
      pauseCard(card);
    } else {
      playCard(card);
    }
  }

  cards.forEach(function (card) {
    const video = card.querySelector("video");
    const media = card.querySelector(".visual-proof__media");
    const playBtn = card.querySelector("[data-visual-proof-play]");
    const muteBtn = card.querySelector("[data-visual-proof-mute]");

    setPlayIcon(card, false);
    setMuteIcon(card, true);

    if (media) {
      media.addEventListener("click", function (event) {
        if (event.target.closest("[data-visual-proof-mute]")) return;
        event.preventDefault();
        toggleCard(card);
      });
    }

    if (playBtn) {
      playBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleCard(card);
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!video || !card.classList.contains("is-playing")) return;
        video.muted = !video.muted;
        setMuteIcon(card, video.muted);
      });
    }

    if (video) {
      video.addEventListener("ended", function () {
        pauseCard(card);
        video.currentTime = 0;
      });
    }
  });

  prevButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slidePrev();
    });
  });

  nextButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slideNext();
    });
  });

  swiper.on("slideChange", updateNavState);
  swiper.on("reachBeginning", updateNavState);
  swiper.on("reachEnd", updateNavState);
  swiper.on("fromEdge", updateNavState);
  updateNavState();
})();
